const breakpoint = {
  sp: 768 - 1,
  tab: 1080 - 1,
};
const getMediaQuery = (key: keyof typeof breakpoint): string => `@media (max-width: ${breakpoint[key]}px)`;

export default getMediaQuery;
